import { HAS_WINDOW } from '@eventbrite/feature-detection';

export const getDrawerHeight = () => {
    if (!HAS_WINDOW) return 550;

    return 0.85 * window.innerHeight;
};
